import getProp from '@f/get-prop'

const getSourceTrackEvents = (state, workspaceSlug, sourceSlug) => {
  const workspaceTrackEvents = getProp(`sourceTrackEvents.${workspaceSlug}`, state) || {}
  // Legacy sourceSlug's can contain dots
  return workspaceTrackEvents[sourceSlug] || {}
}

export const getSourceTrackEventsRequest = (state, workspaceSlug, sourceSlug) => {
  const { isRequesting, didRequestFail, hasRequested } = getSourceTrackEvents(state, workspaceSlug, sourceSlug)
  return { isRequesting, didRequestFail, hasRequested }
}

export const getSourceTrackEventsData = (state, workspaceSlug, sourceSlug) => {
  const { data = {} } = getSourceTrackEvents(state, workspaceSlug, sourceSlug)
  return data
}



// WEBPACK FOOTER //
// ./selectors/source-track-events.js